import { Modal } from "antd";
import Lottie from "lottie-react";
import loaderjson from "../../assets/loader.json";
const Loader = (props) => {
    const { loading } = props;
    return (
        <Modal transparent={true} centered footer={null} closable={false} maskClosable={false} visible={loading} width={100}>
            <Lottie animationData={loaderjson} style={{ height: 85, background: "white", borderRadius:8 }} />
        </Modal>
    );
};

export default Loader;